function b64ToUint8Array(b64Image) {
  const img = atob(b64Image.split(',')[1]);
  const img_buffer = [];
  let i = 0;
  while (i < img.length) {
    img_buffer.push(img.charCodeAt(i));
    i++;
  }
  return new Uint8Array(img_buffer);
}

export { b64ToUint8Array };
